// src/components/MfaPrompt.jsx
import { useState } from 'react';

const API = process.env.REACT_APP_API_URL || 'http://localhost:4242';

export default function MfaPrompt({ uid, onSuccess, onCancel }) {
  const [code, setCode] = useState('');
  const [error, setErr] = useState('');

  const verify = async () => {
    const res = await fetch(`${API}/mfa/login`, {
      method :'POST',
      headers:{ 'Content-Type':'application/json' },
      body   : JSON.stringify({ uid, token: code })
    });
    if (res.ok) {
      localStorage.setItem(`mfa:${uid}`, 'true');
      onSuccess();
    } else {
      setErr('Invalid code');
    }
  };

  return (
    <div className="mfa-modal">
      <div className="mfa-box">
        <h3>Enter 6-digit authenticator code</h3>
        <input
          value={code}
          onChange={e=>setCode(e.target.value)}
          placeholder="123 456"
        />
        <button onClick={verify}>Verify</button>
        <button onClick={onCancel}>Cancel</button>
        {error && <p className="err">{error}</p>}
      </div>
    </div>
  );
}
